import { createClient } from 'contentful';

var client;

if (process.env.NODE_ENV === 'development') {
  client = createClient({
    space: process.env.CONTENTFUL_SPACE_ID,
    accessToken: process.env.CONTENTFUL_PREVIEW_ACCESSTOKEN,
    host: process.env.CONTENTFUL_PREVIEW_API_URL,
  });
} else {
  client = createClient({
    space: process.env.CONTENTFUL_SPACE_ID,
    accessToken: process.env.CONTENTFUL_ACCESSTOKEN,
  });
}

export function fetchPageContent(pageType) {
  return client
    .getEntries({
      content_type: pageType,
      include: 10,
    })
    .then((response) => {
      return response.items[0].fields;
    });
}

export function fetchEntriesByField(
  contentType,
  fieldName,
  fieldValue,
  onlyFirst = true
) {
  return client
    .getEntries({
      [`fields.${fieldName}`]: fieldValue,
      content_type: contentType,
      include: 10,
    })
    .then((response) => {
      if (onlyFirst) {
        return response.items[0].fields;
      } else {
        return response.items;
      }
    });
}

export function fetchEntries(contentType) {
  return client
    .getEntries({
      content_type: contentType,
    })
    .then((response) => {
      return response.items;
    });
}
